// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"92ac21a5","579":"b4139081"}[chunkId] + ".css";
};